import { render } from "./JoinUsView.vue?vue&type=template&id=52c007e5&scoped=true"
import script from "./JoinUsView.vue?vue&type=script&lang=js"
export * from "./JoinUsView.vue?vue&type=script&lang=js"

import "./JoinUsView.vue?vue&type=style&index=0&id=52c007e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c007e5"]])

export default __exports__